
import { logError } from '@/utils/errorLogger';

// Utility functions for API operations
export const handleApiError = (error: any, source: string, message: string) => {
  logError({
    type: 'api',
    message: `${message}: ${error.message}`,
    source,
    stack: error.stack,
  });
  console.error(`Error in ${source}:`, error);
};
